import { React, useState, useEffect } from "react";
import { grid1, grid2, grid3, grid4, tick, copy } from "../../assets";
import { Link } from "react-scroll";
import { useInView } from "react-intersection-observer";
import anime from "animejs/lib/anime.es.js";
import Globe from "react-globe.gl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const AboutNew = () => {
  const [hasCopied, sethasCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText("kishore231512@gmail.com");
    sethasCopied(true);

    setTimeout(() => {
      sethasCopied(false);
    }, 2000);
  };

  const { ref: aboutSection, inView: isIntersectingSkills } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  useEffect(() => {
    let aboutAnimation = anime.timeline({
      easing: "easeOutExpo",
      duration: 8000,
      autoplay: false,
    });

    aboutAnimation.add({
      targets: ".grid1",
      easing: "easeInOutQuad",
      opacity: [0, 1],
      translateX: ["-30%", "0%"],
      duration: 1500,
    });
    aboutAnimation.add(
      {
        targets: ".grid4",
        easing: "easeInOutQuad",
        opacity: [0, 1],
        translateX: ["-30%", "0%"],
        duration: 1500,
      },
      "-100"
    );
    aboutAnimation.add(
      {
        targets: ".grid2",
        easing: "easeInOutQuad",
        opacity: [0, 1],
        translateY: ["-30%", "0%"],
        duration: 1500,
      },
      "-100"
    );
    aboutAnimation.add(
      {
        targets: ".grid3",
        easing: "easeInOutQuad",
        opacity: [0, 1],
        translateX: ["30%", "0%"],
        duration: 1500,
      },
      "-100"
    );

    aboutAnimation.add(
      {
        targets: ".grid5",
        easing: "easeInOutQuad",
        opacity: [0, 1],
        translateY: ["30%", "0%"],
        duration: 1500,
      },
      "-100"
    );

    if (isIntersectingSkills) {
      aboutAnimation.play();
      return;
    }
  }, [isIntersectingSkills]);

  return (
    <section
      ref={aboutSection}
      id="about"
      className="lg:py-[6rem] lg:mt-[1rem] lg:px-[8rem] px-10"
    >
      <div className="grid xl:grid-cols-3 xl:grid-rows-6 md:grid-cols-2 grid-cols-1 gap-5 h-full">
        <div className="col-span-1 xl:row-span-3 grid1">
          <div className="grid-container">
            <img
              src={grid1}
              alt="grid-1"
              className="w-full sm:h-[276px] h-fit object-contain"
            />
            <div>
              <p className="grid-headtext">Always Exploring</p>
              <p className="grid-subtext">
              Exploring the intersection of GenAI, multimodal reasoning, and automation to create intelligent experiences that bridge human insight with machine reasoning.
              </p>
            </div>
          </div>
        </div>

        <div className="col-span-1 xl:row-span-3 grid2">
          <div className="grid-container">
            <img
              src={grid2}
              alt="grid2"
              className="w-full mx-auto sm:w-[276px] h-fit object-contain"
            />
            <div>
              <p className="grid-headtext">Tech Stack</p>
              <p className="grid-subtext">
              From frontend polish to backend precision, I work across the stack — blending web technologies, cloud platforms, and AI systems to turn complex ideas into smart, scalable products.
              </p>
            </div>
          </div>
        </div>

        <div className="col-span-1 xl:row-span-4 grid3">
          <div className="grid-container">
            <div className="rounded-3xl w-full sm:h-[326px] xl:h-[406px] h-fit flex justify-center items-center">
              <Globe
                height={356}
                width={356}
                backgroundColor="rgba(0,0,0,0)"
                backgroundImageOpacity={0.5}
                showAtmosphere
                showGraticules
                globeImageUrl="//unpkg.com/three-globe/example/img/earth-night.jpg"
                bumpImageUrl="//unpkg.com/three-globe/example/img/earth-topology.png"
                labelsData={[
                  {
                    lat: 48.380894,
                    lng: -89.247681,
                    text: "I'm here!",
                    size: 1000,
                  },
                ]}
              />
            </div>
            <div>
              <p className="grid-headtext md:mt-[-2rem]">
                I work remotely across most time zones!
              </p>
              <p className="grid-subtext">
                I'm based in Canada with remote work available.
              </p>
              <Link
                to="contact"
                spy={true}
                smooth={true}
                offset={0}
                duration={750}
              >
                <button className={`btn w-full mt-4 text-[18px]`}>
                  <span className="relative flex h-3 w-3">
                    <span className="btn-ping"></span>
                    <span className="btn-ping_dot"></span>
                  </span>
                  Contact Me
                </button>
              </Link>
              <a href="/Resume.pdf" download="Resume.pdf">
                <button
                  className={`btn w-full mt-4 text-[15px] border !border-[#7f5b4d]`}
                >
                  <div className="mr-[-5px] text-[13px]">
                    <FontAwesomeIcon
                      icon="fa-solid fa-download"
                      className="mr-0"
                    />
                  </div>
                  Resume
                </button>
              </a>
            </div>
          </div>
        </div>

        <div className="xl:col-span-2 xl:row-span-3 grid4">
          <div className="grid-container">
            <img
              src={grid3}
              alt="grid3"
              className="w-full sm:h-[300px] h-full object-contain flex items-center justify-center"
            />
            <div>
              <p className="grid-headtext md:mt-[1rem] xl:mt-[1.5rem]">
                My Passion for Coding
              </p>
              <p className="grid-subtext">
              Coding is where creativity meets logic for me. I love building things that solve real problems, from smart AI systems to beautifully engineered web apps. I'm constantly exploring new tools to push what's possible.
              </p>
            </div>
          </div>
        </div>

        <div className="xl:col-span-1 xl:row-span-2 grid5">
          <div className="grid-container">
            <img
              src={grid4}
              alt="grid4"
              className="w-full lg:h-[180px] md:h-[106px] h-fit object-cover sm:object-top"
            />
            <div className="space-y-2">
              <p className="grid-subtext text-center">Contact me</p>
              <div className="copy-container" onClick={handleCopy}>
                <img src={hasCopied ? tick : copy} alt="copy" />
                <p className="lg:text-xl md:text-lg font-medium text-white-600">
                  kishore231512@gmail.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutNew;
